(() => {
  if (window.themePdpOptionSelect) return;
  const controllers = new WeakMap();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-theme-pdp-select-control]').forEach((control) => {
      if (controllers.has(control)) return;
      const select = control.querySelector('[data-theme-pdp-option-select]');
      if (!select) return;
      const desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      const touch = window.matchMedia('(any-pointer: coarse)');
      const label = select.labels?.[0] || document.getElementById?.(select.getAttribute?.('aria-labelledby'));
      const nativeLabelFor = select.labels?.[0] ? (label.htmlFor || select.id) : undefined;
      const labelId = `${select.id}-label`;
      if (label) label.id = label.id || labelId;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = `${select.className || 'theme-main-product__variant-select'} theme-pdp-option-select__trigger`;
      trigger.id = `${select.id}-trigger`;
      trigger.setAttribute('role', 'combobox');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', `${select.id}-listbox`);
      if (label) trigger.setAttribute('aria-labelledby', `${label.id} ${trigger.id}`);
      const list = document.createElement('div');
      list.id = `${select.id}-listbox`;
      list.className = 'theme-pdp-option-select__listbox';
      list.setAttribute('role', 'listbox');
      if (label) list.setAttribute('aria-labelledby', label.id);
      list.hidden = true;
      trigger.hidden = true;
      control.append(trigger, list);
      let open = false;
      let active = -1;
      let items = [];
      let typed = '';
      let typedAt = 0;
      const enabled = () => items.map((item, index) => select.options[index].disabled ? -1 : index).filter(index => index >= 0);
      const paintActive = () => {
        items.forEach((item, index) => {
          item.dataset.active = String(open && active === index);
          item.setAttribute('aria-selected', String(open ? active === index : select.options[index].selected));
        });
        if (open && items[active]) {
          trigger.setAttribute('aria-activedescendant', items[active].id);
          const item = items[active];
          if (item.offsetTop < list.scrollTop) list.scrollTop = item.offsetTop;
          else if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
        } else trigger.removeAttribute('aria-activedescendant');
      };
      const close = () => {
        open = false;
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        typed = '';
        paintActive();
      };
      const sync = () => {
        trigger.textContent = select.selectedOptions[0]?.textContent || '';
        trigger.disabled = select.disabled;
        if (items.length !== select.options.length) {
          items = Array.from(select.options, (option, index) => {
            const item = document.createElement('div');
            item.id = `${list.id}-${index}`;
            item.className = 'theme-pdp-option-select__option';
            item.setAttribute('role', 'option');
            item.dataset.index = String(index);
            return item;
          });
          list.replaceChildren(...items);
        }
        items.forEach((item, index) => {
          item.textContent = select.options[index].textContent;
          item.setAttribute('aria-disabled', String(select.options[index].disabled));
        });
        if (!open || select.options[active]?.disabled) active = select.selectedIndex;
        paintActive();
      };
      const show = () => {
        if (!desktop.matches || touch.matches || trigger.disabled) return;
        sync();
        open = true;
        active = select.selectedIndex;
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        const rect = trigger.getBoundingClientRect();
        let top = 0;
        let bottom = window.innerHeight;
        for (let parent = control.parentElement; parent; parent = parent.parentElement) {
          const overflow = window.getComputedStyle(parent).overflowY;
          if (!['auto', 'scroll', 'hidden', 'clip'].includes(overflow)) continue;
          const bounds = parent.getBoundingClientRect();
          top = Math.max(top, bounds.top);
          bottom = Math.min(bottom, bounds.bottom);
        }
        const below = bottom - rect.bottom - 12;
        const above = rect.top - top - 12;
        const upwards = below < 132 && above > below;
        list.style.insetBlockStart = upwards ? 'auto' : 'calc(100% + 4px)';
        list.style.insetBlockEnd = upwards ? 'calc(100% + 4px)' : 'auto';
        list.style.maxHeight = `${Math.max(44, Math.min(352, upwards ? above : below))}px`;
        paintActive();
      };
      const commit = (index = active) => {
        const option = select.options[index];
        if (!option || option.disabled) return;
        const changed = select.value !== option.value;
        select.value = option.value;
        close();
        if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      };
      const updateMode = () => {
        const focused = document.activeElement;
        close();
        const enhanced = desktop.matches && !touch.matches;
        select.hidden = enhanced;
        trigger.hidden = !enhanced;
        control.dataset.enhanced = String(enhanced);
        if (label && nativeLabelFor !== undefined) label.htmlFor = enhanced ? trigger.id : select.id;
        sync();
        if (enhanced && focused === select) trigger.focus();
        else if (!enhanced && focused === trigger) select.focus();
      };
      trigger.addEventListener('click', () => open ? close() : show());
      trigger.addEventListener('keydown', (event) => {
        const key = event.key;
        if (key === 'Tab') { if (open) commit(); return; }
        if (key === 'Escape') { if (open) { event.preventDefault(); close(); } return; }
        if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'].includes(key)) {
          event.preventDefault();
          const wasOpen = open;
          if (!open) show();
          if (key === 'Enter' || key === ' ') { if (wasOpen) commit(); return; }
          const available = enabled();
          const current = available.indexOf(active);
          if (key === 'Home' || (!wasOpen && key === 'ArrowUp')) active = available[0];
          else if (key === 'End') active = available[available.length - 1];
          else if (wasOpen) {
            const direction = key === 'ArrowUp' || key === 'PageUp' ? -1 : 1;
            const distance = key.startsWith('Page') ? 10 : 1;
            active = available[Math.max(0, Math.min(available.length - 1, current + direction * distance))];
          }
          if (event.altKey && key === 'ArrowUp' && wasOpen) commit();
          else paintActive();
          return;
        }
        if (key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return;
        event.preventDefault();
        if (!open) show();
        const now = Date.now();
        typed = now - typedAt > 700 ? key.toLowerCase() : typed + key.toLowerCase();
        typedAt = now;
        const query = Array.from(typed).every(char => char === typed[0]) ? typed[0] : typed;
        const available = enabled();
        const start = query.length === 1 ? available.indexOf(active) + 1 : 0;
        for (let offset = 0; offset < available.length; offset += 1) {
          const index = available[(start + offset) % available.length];
          if (select.options[index].textContent.trim().toLowerCase().startsWith(query)) { active = index; break; }
        }
        paintActive();
      });
      list.addEventListener('pointerdown', (event) => event.preventDefault());
      list.addEventListener('click', (event) => {
        const item = event.target.closest('[data-index]');
        if (item && list.contains(item)) commit(Number(item.dataset.index));
      });
      const outside = (event) => { if (open && !control.contains(event.target)) close(); };
      const blur = () => { if (open) commit(); };
      trigger.addEventListener('blur', blur);
      const nativeChange = () => queueMicrotask(sync);
      select.addEventListener('change', nativeChange);
      const observer = new MutationObserver(sync);
      observer.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected'] });
      document.addEventListener('pointerdown', outside);
      desktop.addEventListener('change', updateMode);
      touch.addEventListener('change', updateMode);
      const resize = () => { if (open) close(); };
      window.addEventListener('resize', resize);
      const destroy = () => {
        close();
        observer.disconnect();
        document.removeEventListener('pointerdown', outside);
        desktop.removeEventListener('change', updateMode);
        touch.removeEventListener('change', updateMode);
        window.removeEventListener('resize', resize);
        select.removeEventListener('change', nativeChange);
        document.removeEventListener('shopify:section:unload', unload);
        select.hidden = false;
        if (label && nativeLabelFor !== undefined) label.htmlFor = nativeLabelFor;
        trigger.remove();
        list.remove();
        delete control.dataset.enhanced;
        controllers.delete(control);
      };
      const unload = (event) => { if (event.target.contains(control)) destroy(); };
      document.addEventListener('shopify:section:unload', unload);
      controllers.set(control, { sync, destroy });
      updateMode();
    });
  };
  const destroy = (scope) => {
    scope?.querySelectorAll('[data-theme-pdp-select-control]').forEach((control) => controllers.get(control)?.destroy());
  };
  window.themePdpOptionSelect = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
